import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { settingsService } from '@/services/settings.service';
import { toast } from 'sonner';
import i18n from '@/i18n';

export const settingsKeys = {
  all: ['settings'] as const,
  apiKey: () => [...settingsKeys.all, 'api-key'] as const,
};

export function useApiKey() {
  return useQuery({
    queryKey: settingsKeys.apiKey(),
    queryFn: () => settingsService.getApiKey(),
  });
}

export function useGenerateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => settingsService.generateApiKey(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.apiKey() });
      toast.success(i18n.t('adminSettings:toasts.apiKeyGenerated'));
    },
    onError: () => {
      toast.error(i18n.t('adminSettings:toasts.apiKeyGenerateError'));
    },
  });
}

export function useRegenerateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => settingsService.regenerateApiKey(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.apiKey() });
      toast.success(i18n.t('adminSettings:toasts.apiKeyRegenerated'));
    },
    onError: () => {
      toast.error(i18n.t('adminSettings:toasts.apiKeyRegenerateError'));
    },
  });
}
